import {ELanguage, languages} from "../../../lang/ELanguage";
import {CURRENT_LANGUAGE_KEY} from "./LocalStorageKeys";
import {ILanguage} from "../../../lang/ILanguage";

class LanguageService {

    private _store = localStorage;

    public getCurrentLanguage(): ELanguage | undefined {
        let currentLanguage: ELanguage | undefined = undefined;
        const jsonLanguage = this._store.getItem(CURRENT_LANGUAGE_KEY);
        if(jsonLanguage) {
            try {
                currentLanguage = JSON.parse(jsonLanguage) as ELanguage;
            } catch (e) {
                console.log(e);
            }
        }
        return currentLanguage;
    }

    public createCurrentLanguage(language: ELanguage): boolean {
        let isAdd = false;
        try {
            const stringify = JSON.stringify(language);
            this._store.setItem(CURRENT_LANGUAGE_KEY, stringify);
            isAdd = true;
        } catch (e) {
            console.log(e);
        }
        return isAdd;
    }

    public deleteCurrentLanguage(): boolean {
        let isDelete = false;
        try {
            this._store.removeItem(CURRENT_LANGUAGE_KEY);
            isDelete = true;
        } catch (e) {
            console.log(e);
        }
        return isDelete;
    }

    public getLanguage(language: ELanguage): ILanguage {
        const index = languages.findIndex((value) => (value.languageAbbreviation === language));
        return languages[index];
    }

}

export default new LanguageService();
